<div class="gcontainer bwhite">
  <div class="row breadcrumb-header align-items-center sticky-header">
    <div class="col-md-8">
      <nav aria-label="breadcrumb" class="mt-8">
        <ol class="breadcrumb">
          <li class="breadcrumb-item active breadcrumb cursor" aria-current="page" (click)="reDirectUrl()" tabindex="0">
            Dashboard
          </li>
          <li class="breadcrumb-item active breadcrumb cursor" aria-current="page" (click)="backToWorksheet()" tabindex="0">
            Moisture Conditioning
          </li>
          <li class="breadcrumb-item active" aria-current="page">History</li>
        </ol>
      </nav>
    </div>
    <div class="col-md-4 d-flex justify-content-end">
      <button mat-raised-button (click)="backToWorksheet()">
        <mat-icon>arrow_back</mat-icon>
        Back to Moisture Conditioning
      </button>
    </div>
  </div>

  <div class="history-title">
    <h1 class="mat-h1">Moisture Conditioning History@if (referenceId) {
      : {{ referenceId }}
    }</h1>
    @if (companyName || projectName) {
      <p>{{ companyName }}@if (companyName && projectName) {
        <span> - </span>
      }{{ projectName }}</p>
    }
  </div>

  @if (isLoading) {
    <p class="history-empty">Loading history...</p>
  }
  @if (!isLoading && events.length === 0) {
    <p class="history-empty">No saves or assignments have been recorded for this worksheet yet.</p>
  }

  @if (!isLoading && events.length > 0) {
    <app-history-timeline [events]="events" [(selectedIndex)]="selectedIndex"></app-history-timeline>
    <!-- SELECTED ACTION -->
    @if (selectedEvent; as event) {
      <div class="selected-event">
        <div class="selected-header">
          <span class="selected-time">
            {{ event.changedAt | utcToLocal: 'date' }} {{ event.changedAt | utcToLocal: 'time' }}
          </span>
          <span class="selected-user">{{ event.changedBy }}</span>
          <span class="selected-action" [class.assigned]="event.action === 'Assigned'">{{ event.action }}</span>
          <span class="selected-summary">
            {{ changedRowCount(event) }} of {{ event.rows.length }} row(s) changed@if (changedFieldCount(event) > 0) {
            <span>, {{ changedFieldCount(event) }} change(s)</span>
          }
        </span>
      </div>
      <table mat-table [dataSource]="event.rows" class="material-table custom-table history-table">
        <ng-container matColumnDef="sampleId">
          <th mat-header-cell *matHeaderCellDef>Sample Id</th>
          <td mat-cell *matCellDef="let row">{{ row.sampleId ?? '—' }}</td>
        </ng-container>
        <ng-container matColumnDef="compactionEffort">
          <th mat-header-cell *matHeaderCellDef>Compaction Effort</th>
          <td mat-cell *matCellDef="let row">{{ row.compactionEffort }}</td>
        </ng-container>
        <ng-container matColumnDef="depth">
          <th mat-header-cell *matHeaderCellDef>Depth</th>
          <td mat-cell *matCellDef="let row">{{ displayDepth(row) }}</td>
        </ng-container>
        <!-- One line per moisture test, kept on the same line across the three test columns -->
        <ng-container matColumnDef="testNo">
          <th mat-header-cell *matHeaderCellDef>M/C#</th>
          <td mat-cell *matCellDef="let row" class="test-cell">
            @for (test of row.tests; track test) {
              <div
                class="test-line"
                [ngClass]="'test-' + test.change.toLowerCase()">
                <span class="test-number">{{ test.testNumber }}</span>
                @if (testChangeLabel(test.change)) {
                  <span class="test-change">{{ testChangeLabel(test.change) }}</span>
                }
              </div>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="drySoil">
          <th mat-header-cell *matHeaderCellDef>Amount of Dry Soil</th>
          <td mat-cell *matCellDef="let row" class="test-cell">
            @for (test of row.tests; track test) {
              <div
                class="test-line"
                [ngClass]="'test-' + test.change.toLowerCase()"
                [class.changed-cell]="test.drySoil.changed">
                <ng-container *ngTemplateOutlet="testValue; context: { $implicit: test.drySoil, change: test.change }"></ng-container>
              </div>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="moistureContent">
          <th mat-header-cell *matHeaderCellDef>Moisture Content</th>
          <td mat-cell *matCellDef="let row" class="test-cell">
            @for (test of row.tests; track test) {
              <div
                class="test-line"
                [ngClass]="'test-' + test.change.toLowerCase()"
                [class.changed-cell]="test.moistureContent.changed">
                <ng-container *ngTemplateOutlet="testValue; context: { $implicit: test.moistureContent, change: test.change }"></ng-container>
              </div>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="assignedTo">
          <th mat-header-cell *matHeaderCellDef>Assigned To</th>
          <td mat-cell *matCellDef="let row" [class.changed-cell]="row.assignedTo.changed">
            <ng-container *ngTemplateOutlet="fieldCell; context: { $implicit: row.assignedTo, isStatus: false }"></ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let row" [class.changed-cell]="row.status.changed">
            <ng-container *ngTemplateOutlet="fieldCell; context: { $implicit: row.status, isStatus: true }"></ng-container>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; let i = index; columns: displayedColumns"
          [class.first-record]="row.isFirstRecord"
          [class.changed-row]="row.changedInAction"
          [class.dotted-bottom-border]="isLastRowOfEffort(event.rows, i)"
        [class.bold-bottom-border]="isLastRowOfSample(event.rows, i)"></tr>
      </table>
    </div>
  }
}
</div>

<!-- Current value, plus the previous one struck through when the field changed -->
<ng-template #fieldCell let-field let-isStatus="isStatus">
  <span class="current-value">{{ displayValue(field.current, isStatus) }}</span>
  @if (field.changed) {
    <span class="previous-value">{{ displayValue(field.previous, isStatus) }}</span>
  }
</ng-template>

<!-- A test's value on one line: a removed test shows its last value struck through; an edited value shows the old one beside it -->
<ng-template #testValue let-field let-change="change">
  @if (change === 'Removed') {
    <span class="removed-value">{{ displayValue(field.previous) }}</span>
  } @else {
    <span>{{ displayValue(field.current) }}</span>
    @if (field.changed) {
      <span class="previous-inline">{{ displayValue(field.previous) }}</span>
    }
  }
</ng-template>
